<template>
  <div class="layout-flex">
    <div class="item-title">
      <div class="item-line" :style="{'font-size': isSubEnShow?'20px':'16px'}">
        <img v-if="isIconShow" class="item-iconTit" src="../../assets/meb/imgsMobile/mIconTit@2x.png" />
        {{listObj.title}}
      </div>
    </div>
    <div class="item-title-sub" v-if="isSubShow">{{listObj.subtitle}}</div>
    <div class="item-title-sub" v-if="isSubEnShow">{{listObj.subtitleEn}}</div>
    <div class="item-dec" v-html="listObj.dec"></div>
    <div class="item-video">
      <contentVideo v-if="listObj.videourl" :url="listObj.videourl" :img="listObj.videoimgMobile"></contentVideo>
      <contentImage v-if="listObj.imageurlMobile" :url="listObj.imageurlMobile"></contentImage>
    </div>
    <div v-if="listObj.imgs.length" class="item-img-content">
      <img class="item-img" v-for="(item,index) in listObj.imgs" :key="index" :src="item" />
    </div>
    <div class="item-dec" v-if="isDecEnShow" v-html="listObj.decEn"></div>
  </div>
</template>

<script>
import contentVideo from "./contentVideo.vue";
import contentImage from "./contentImage.vue";
export default {
  components: {
    contentVideo,
    contentImage
  },
  props: {
    list: {},
    isIconShow: {
      type: Boolean,
      default: true
    },
    isSubShow: {
      type: Boolean,
      default: false
    },
    // 是否有英文副标题
    isSubEnShow: {
      type: Boolean,
      default: false
    },
    //是否有英文详情
    isDecEnShow: {
      type: Boolean,
      default: false
    },
    isBtnShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listObj: this.list
    };
  },
  mounted() {
    console.log(this.listObj);
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.layout-flex {
  width: 375px;
  padding: 20px 10px 20px 10px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
}

.layout-flex {
  .item-line {
    float: left;
    border-bottom: 3px solid rgba(40, 132, 244, 0.2);
  }
  .item-iconTit {
    width: 16px;
    height: 16px;
    padding-right: 5px;
  }
  .item-title {
    height: 30px;
    line-height: 16px;
    font-size: 20px;
    font-weight: 400;
    color: #0077c8;
  }
  .item-title-sub {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    clear: both;
    margin-top: 5px;
  }
  .item-dec {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    margin-top: 16px;
  }
  .item-video {
    margin-top: 25px;
  }
  .item-btn {
    width: 100px;
    border: 1px solid #666666;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-top: 22px;
    cursor: pointer;
  }
  .item-img-content {
    height: 120px;
    margin-top: 20px;
  }
  .item-img {
    width: 170px;
    height: 120px;
    margin-left: 15px;
  }
  .item-img:first-child {
    margin-left: 0px;
  }
}
</style>
